import type { ClientNutritionDay } from "@fitness-app/data-models/entities/ClientNutritionDay";

/** The RPC reports SQL failures inside its JSON envelope, even with HTTP 200. */
export const parseNutritionDayResponse = (response: unknown): ClientNutritionDay => {
  const envelope = response as { data?: ClientNutritionDay; error?: { message?: string } } | null;
  if (envelope?.error) {
    throw new Error(envelope.error.message || "Nie udało się zapisać dnia");
  }
  const day = envelope?.data;
  if (!day?.id || !day.day || !day.eventDate) {
    throw new Error("Brak potwierdzenia zapisu dnia");
  }
  return day;
};
